import { DateTime } from 'luxon'

import { Card } from '@/shared/ui'
import { Badge } from '@/shared/ui/Badge'
import { RewardBadge } from '@/shared/ui/RewardBadge'

import { getWalletMovementKind } from '../model/constants'

import type { WalletMovement } from '../model/types'

type WalletMovementCardProps = WalletMovement

const formatAmount = (value?: number | null) =>
  value != null && value > 0 ? value : null

export const WalletMovementCard = ({
  description,
  amount_points,
  amount_coins,
  kind: kindSlug,
  updated_at
}: WalletMovementCardProps) => {
  const kind = getWalletMovementKind(kindSlug)
  const points = formatAmount(amount_points)
  const coins = formatAmount(amount_coins)
  const formattedDate = DateTime.fromISO(updated_at).toLocaleString(
    DateTime.DATETIME_SHORT
  )

  return (
    <Card className="shadow-sm">
      <Card.Body className="flex flex-col gap-3 p-4">
        <div className="flex flex-wrap items-start justify-between gap-2">
          {kind ? (
            <Badge variant={kind.badgeVariant} tone="light" showIcon={false}>
              {kind.name}
            </Badge>
          ) : null}
          <time
            className="shrink-0 text-xs font-semibold text-gray-500"
            dateTime={updated_at}
          >
            {formattedDate}
          </time>
        </div>

        <p className="m-0 whitespace-normal break-words text-sm font-semibold text-gray-800">
          {description}
        </p>

        <div className="flex flex-wrap items-center justify-end gap-3">
          {points != null ? (
            <RewardBadge type="xp" value={points} variant="inline" />
          ) : (
            <span className="text-sm font-semibold text-gray-400">—</span>
          )}
          {coins != null ? (
            <RewardBadge type="coins" value={coins} variant="inline" />
          ) : (
            <span className="text-sm font-semibold text-gray-400">—</span>
          )}
        </div>
      </Card.Body>
    </Card>
  )
}
